import Typography from '@mui/material/Typography'
import React, { ReactNode } from 'react'

// Wrapper function that adds italic based on a condition
export const ItalicWrapper = ({ isItalic, children }: { isItalic: boolean; children: ReactNode }) => {
    return <Typography sx={{ fontStyle: isItalic ? 'italic' : 'normal' }}>{children}</Typography>
}
